import { Component, input, output, signal } from '@angular/core'
import { AbstractControl, FormControl } from '@angular/forms'
import { BndButton } from '@bonduelle-it/storybook'
import { AoNoteDialogComponent, AoNoteDialogData } from '../ao-note-dialog/ao-note-dialog.component'

@Component({
  selector: 'ao-note-button',
  imports: [BndButton, AoNoteDialogComponent],
  templateUrl: './ao-note-button.component.html',
})
export class AoNoteButtonComponent {
  readonly noteFormControl = input<AbstractControl>()
  /**
   * If set, overrides the noteFormControl and disable the possibility to edit the note
   */
  readonly noteValue = input<string>()

  readonly mode = input<ReturnType<BndButton['mode']>>('ghost')
  readonly buttonSize = input<ReturnType<BndButton['size']>>('md')

  readonly shape = input<ReturnType<BndButton['shape']>>('square')

  readonly iconWidth = input(40)
  readonly iconHeight = input(40)
  readonly fontSize = input(40)

  readonly iconClass = input('text-[var(--grey-light-icon)]')

  readonly buttonColor = input<ReturnType<BndButton['color']>>('default')

  readonly noteChange = output<string | null>()

  protected readonly isNoteModalOpen = signal(false)
  protected noteDialogData?: AoNoteDialogData

  get isReadonly(): boolean {
    return !!this.noteValue()
  }

  get iconName(): string {
    return this.isReadonly ? 'pi-file' : 'pi-file-edit'
  }

  openNoteDialog() {
    let formControl = this.noteFormControl()
    const noteValue = this.noteValue()
    if (!formControl || noteValue) {
      formControl = new FormControl({ value: noteValue, disabled: true })
    }
    this.noteDialogData = { noteFormControl: formControl }
    this.isNoteModalOpen.set(true)
  }

  onNoteDialogResult(value: string | null | undefined): void {
    this.isNoteModalOpen.set(false)
    if (value === undefined) return
    this.noteChange.emit(value)
  }
}
